"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDatahub = exports.REASON = exports.LEVEL = exports.EVENT_NAME = void 0;
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
const env_1 = require("./env");
const EVENT_SYSTEM = 'cas-js';
var EVENT_NAME;
(function (EVENT_NAME) {
    EVENT_NAME["EXPIRED_TOKEN"] = "expired_token";
    EVENT_NAME["EXPIRING_TOKEN"] = "expiring_token";
    EVENT_NAME["LOGOUT"] = "logout";
    EVENT_NAME["USER_LOADED"] = "user_loaded";
    EVENT_NAME["USER_UNLOADED"] = "user_unloaded";
    // For contexts with user data
    EVENT_NAME["RENEWING"] = "renewing";
    EVENT_NAME["RENEW_ERROR"] = "renew_error";
    // For contexts without user data
    EVENT_NAME["SIGNING_SILENT"] = "signing_silent";
    EVENT_NAME["SIGNIN_SILENT_ERROR"] = "signin_silent_error";
    // For session monitor responses
    EVENT_NAME["VALID_SESSION"] = "valid_session";
    EVENT_NAME["INVALID_SESSION"] = "invalid_session";
})(EVENT_NAME || (EVENT_NAME = {}));
exports.EVENT_NAME = EVENT_NAME;
var LEVEL;
(function (LEVEL) {
    LEVEL["ERROR"] = "ERROR";
    LEVEL["SUCCESS"] = "SUCCESS";
    LEVEL["INFO"] = "INFO";
})(LEVEL || (LEVEL = {}));
exports.LEVEL = LEVEL;
var REASON;
(function (REASON) {
    // For logout
    REASON["API_ERROR"] = "api_error";
    REASON["INVALID_SESSION"] = "invalid_session";
    REASON["RENEW_ERROR"] = "renew_error";
    REASON["USER"] = "user";
    // For revalidate
    REASON["FOCUS"] = "focus";
    REASON["INIT"] = "init";
    REASON["LOGOUT"] = "logout";
    REASON["ONLINE"] = "online";
    // For renew
    REASON["RENEW"] = "renew";
})(REASON || (REASON = {}));
exports.REASON = REASON;
event_agent_js_1.default.mode = env_1.isProd ? 'production' : 'staging';
const sendDatahub = (event, entity = 'global', action = 'send') => {
    const data = { system: EVENT_SYSTEM, action, entity, event };
    if (env_1.isLocal) {
        return localStorage.setItem(`cas-js:event:${Date.now()}:${Math.random() * 10e4 | 0}:${event.name}`, JSON.stringify(data));
    }
    try {
        event_agent_js_1.default.send(data);
    }
    catch (error) {
        console.error(error);
    }
};
exports.sendDatahub = sendDatahub;
